export const EXCHANGE_RATES_TO_GBP: Record<"GBP" | "USD" | "EUR", number> = {
  GBP: 1,
  USD: 0.8,
  EUR: 0.85
};

export const CURRENCY_SYMBOL_TO_CODE: Record<"£" | "$" | "€", "GBP" | "USD" | "EUR"> = {
  "£": "GBP",
  $: "USD",
  "€": "EUR"
};
